import {createSlice} from '@reduxjs/toolkit';
import {PURGE} from 'redux-persist'; // This action type is used to clear persisted state.
import {v4 as uuidv4} from 'uuid'; // Importing the uuid library to generate unique IDs for messages.

const initialState = {
  userChats: {}, // Stores chats keyed by user ID
};

// Creating a slice for chat management with Redux Toolkit.
export const chatSlice = createSlice({
  name: 'chat', // Name of the slice, used in action types.
  initialState, // Initial state of the chat slice.
  reducers: {
    // Reducer to add a new message to the chat.
    addMessage: (state, action) => {
      const { userId, message } = action.payload;
      if (!state.userChats[userId]) {
        state.userChats[userId] = [];
      }
      state.userChats[userId].push({
        ...message,
        timestamp: new Date().toISOString(),
      });
    },
    removeLastMessage: (state, action) => {
      const { userId } = action.payload;
      if (state.userChats[userId] && state.userChats[userId].length > 0) {
        state.userChats[userId].pop();
      }
    },
    // Reducer to remove the oldest half of the messages to manage message count.
    removeOldMessages: (state, action) => {
      const { userId } = action.payload;
      if (state.userChats[userId]) {
        const halfLength = Math.floor(state.userChats[userId].length / 2);
        state.userChats[userId].splice(0, halfLength);
      }
    },
    // Reducer to remove a specific message by its ID.
    removeMessage: (state, action) => {
      const { userId, messageId } = action.payload;
      if (state.userChats[userId]) {
        state.userChats[userId] = state.userChats[userId].filter(

          (message) => {return message.id !== messageId}
        );
      }
    },
    resetState: (state, action) => {
      const { userId } = action.payload;
      state.userChats[userId] = [
        {
          id: uuidv4(),
          text: 'Hello I am UniServe 🧠, your Unilever Clearance AI Assistant. How can I help you today?',
          sender: 'bot',
          timestamp: new Date().toISOString(),
        },
      ];
    },
    // Add action to clear specific user's chat
    clearUserChat: (state, action) => {
      const { userId } = action.payload;
      if (state.userChats[userId]) {
        delete state.userChats[userId];
      }
    },
  },
  extraReducers: (builder) => {
    // Handling external actions not defined in this slice.
    builder.addCase(PURGE, () => initialState); // Resets state if storage is cleared using PURGE action.
  },
});

// Exporting actions generated by createSlice for use in components.
export const {
  addMessage,
  removeLastMessage,
  removeOldMessages,
  removeMessage,
  resetState,
  clearUserChat,
} = chatSlice.actions;

// Exporting the reducer to be included in the Redux store.
export default chatSlice.reducer;
